import React from 'react';
import TranslationService from "../../service/TranslationService";
import {CHANNELS, CHOOSE, CHOSEN, MKD} from "../../language-content/keys";
import {useTvChannelsContext} from "../../context/TvChannelsContext";

function TvPackage(props) {
    const {isAdditionalPackageSelectable} = useTvChannelsContext()
    return (
        <div className="col align-self-center mb-4 px-md-1 align-items-center d-flex flex-column">
            <a className={`${props.wrapperClassName} ${props.selected ? "selected" : (!props.selectable ? "disabled" : "")}`}
               onClick={() => props.selectDisplayTvPackage(props.package)}
                /* onClick={() => props.selectPackage ? props.selectPackage(props.package) : null}*/>
                {/*<img src={props.package.imageUrl} alt=""/>*/}
                <div className={"package-name"}>
                    {displayPackageName()}
                </div>

                <a className={"d-block text-uppercase text-underline text-center mt-2 package-channels"}
                    onClick={() => props.selectDisplayTvPackage(props.package)}>
                        {props.package.channelSize} {TranslationService.translate(CHANNELS, props.lang)}
                </a>

                {props.additional &&
                <>
                    <div className="package-price">
                        {props.package.price} {TranslationService.translate(MKD, props.lang)}
                    </div>
                    {/* {isAdditionalPackageSelectable(props.package) &&
                    <div className="is-package-selected">
                        {TranslationService.translate(props.selected ? CHOSEN : CHOOSE, props.lang)}
                    </div>} */}
                </>}
            </a>
            
        </div>
    );

    function displayPackageName() {
        if (props.lang === 'en_US')
            return props.package.nameEN;
        else if (props.lang === 'sq_AL')
            return props.package.nameAL;
        else return props.package.name;
    }
};

export default TvPackage;
